const csvEnvValues = (rawValue, { lowercase = false } = {}) =>
    (rawValue || '')
        .split(',')
        .flatMap((value) => {
            const trimmed = value.trim();
            const normalized = lowercase ? trimmed.toLowerCase() : trimmed;
            return normalized ? [normalized] : [];
        });

const configuredAdminEmails = () =>
    csvEnvValues(process.env.REACT_APP_ADMIN_EMAILS, { lowercase: true });

const configuredAdminAuth0Subs = () =>
    csvEnvValues(process.env.REACT_APP_ADMIN_AUTH0_SUBS);

const ADMIN_EMAIL_CLAIMS = [
    'email',
    'https://dcfteacher.com/email',
    'https://api.dcfteacher.com/email',
];

export const adminEmailFromUser = (user) => {
    if (!user || typeof user !== 'object') {
        return '';
    }

    for (const claim of ADMIN_EMAIL_CLAIMS) {
        const email = String(user[claim] || '').trim().toLowerCase();
        if (email) {
            return email;
        }
    }

    for (const [claim, value] of Object.entries(user)) {
        if (!claim.endsWith('/email')) {
            continue;
        }
        const email = String(value || '').trim().toLowerCase();
        if (email) {
            return email;
        }
    }

    return '';
};

export const isAdminUser = (user) => {
    const email = adminEmailFromUser(user);
    if (email && configuredAdminEmails().includes(email)) {
        return true;
    }

    const auth0Sub = String(user?.sub || '').trim();
    return Boolean(auth0Sub && configuredAdminAuth0Subs().includes(auth0Sub));
};
